import { useEffect, useState } from "react";
import img from "@assets/images/element/forgot-pass.svg";
import { axiosInstanceB2B, Toaster } from "@share/utils";
import { useDispatch, useSelector } from "react-redux";
import { ILoginState, login } from "@share/store/slices";
import { isEmpty } from "lodash";
import { push } from "react-router-redux";
import { Spin, Button, Form } from "antd";
import { InputOTP } from "antd-input-otp";

import './style.scss';
import { FormattedMessage, useIntl } from "react-intl";

function TwoFactorAuth() {
  const loginStore = useSelector((state: { loginStore: ILoginState }) => state.loginStore);
  const intl = useIntl();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (!loginStore?.user) {
      dispatch(push(`/${loginStore?.account?.name}/log-in`));
    }
  }, []);

  const handleResendCode = async () => {
    try {
      setLoading(true);
      const data = { id: loginStore?.user?.userId, email: loginStore?.user?.email };
      await axiosInstanceB2B.post('/identity/users/resend-2fa', data);

      Toaster.success(`${intl.formatMessage({ id: 'verification.code.sent' })}`);
      setLoading(false);
    } catch (error: any) {
      if (!isEmpty(error?.response?.data?.reason)) {
        Toaster.error(error?.response?.data?.reason);
      }
      else {
        Toaster.error(`${intl.formatMessage({ id: 'error.occurred.contact.admin' })}`);
      }
      setLoading(false);
    }
  };

  const handleVerifyAndProceed = async (values: any) => {
    try {
      const { otp } = values;
      if (!otp || otp.length < 6 || otp.includes(undefined) || otp.includes("")) {
        return form.setFields([{ name: "otp", errors: ["Please enter the full code."] }]);
      }

      setLoading(true);
      const data = { id: loginStore?.user?.userId, verificationCode: otp.join('') };
      const response = await axiosInstanceB2B.post('/identity/users/login-2fa', data);
      if (response.data) {
        const userData = { ...loginStore?.user, twoFactorRequire: response.data.twoFactorRequire, accessToken: response.data.accessToken };
        Toaster.success(`${intl.formatMessage({ id: 'verification.success' })}`);
        dispatch(login('', '', false, '', userData));
      }
      setLoading(false);
    } catch (error: any) {
      if (!isEmpty(error?.response?.data?.reason)) {
        Toaster.error(error?.response?.data?.reason);
      }
      else {
        Toaster.error(`${intl.formatMessage({ id: 'error.occurred.contact.admin' })}`);
      }
      setLoading(false);
    }
  };

  return (
    <section className="log-in">
      <div className="container h-100 d-flex px-3 px-md-4 py-3 py-md-0">
        <div className="row justify-content-center align-items-center m-auto" style={{ width: '100%' }}>
          <div className="col-12">
              <div className="shadow bg-mode rounded-3 overflow-hidden">
                <Spin spinning={loading}>
                  <div className="row g-0 align-items-center">
                    <div className="col-lg-6 d-md-flex align-items-center order-2 order-lg-1">
                      <div className="p-3 p-lg-5">
                        <img src={img} alt="ImageTwoFactor" />
                      </div>
                      <div className="vr opacity-1 d-none d-lg-block"></div>
                    </div>

                    <div className="col-lg-6 order-1">
                      <div className="p-4 p-sm-7">
                        <h1 className="mb-2 h3"><FormattedMessage id="two.factor.auth" /></h1>
                        <p className="mb-sm-0">
                          <FormattedMessage id="code.sent" />
                        </p>

                        <Form form={form} onFinish={handleVerifyAndProceed} className="mt-sm-4">
                          <p className="mb-1"><FormattedMessage id="enter.code" />:</p>
                          <div className="autotab d-flex justify-content-between gap-1 gap-sm-3 mb-2">
                            <div className="col-12">
                              <Form.Item
                                name="otp"
                                className="center-error-message"
                                rules={[{ validator: async () => Promise.resolve() }]}
                              >
                                <InputOTP autoFocus inputType="numeric" length={6} inputClassName="form-control text-center" />
                              </Form.Item>
                            </ div>
                          </div>

                          <div className="d-sm-flex justify-content-between small mb-4">
                            <span><FormattedMessage id="didnt.get.code" /></span>
                            <button
                              type="button"
                              className="btn btn-sm btn-link p-0 text-decoration-underline mb-0"
                              onClick={handleResendCode}
                            >
                              <FormattedMessage id="resend" />
                            </button>
                          </div>

                          <div >
                            <Form.Item noStyle>
                              <Button block htmlType="submit" type="primary" className="btn btn-primary w-100" style={{ paddingBottom: '30px' }}>
                                <FormattedMessage id="verify.proceed" />
                              </Button>
                            </Form.Item>
                          </ div>

                          <div className="text-primary-hover mt-3 text-center"><FormattedMessage id="copyright" /></div>
                        </Form>
                      </div>
                    </div>

                  </div>
                </Spin>
              </div>
          </div>
        </div>
      </div >
    </section >
  );
};

export default TwoFactorAuth;
